import { Component } from "@angular/core";
import { ContactFormComponent } from "../../../shared/contact-form/contact-form.component";
import { HeroComponent } from "../../../shared/hero/hero.component";
import { CEO_CONFIG } from "../../../shared/contact-form/contact-config";
import { ContentComponent } from "../../components/content/content.component";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["./privacy-policy.component.scss"],
  imports: [HeroComponent, ContactFormComponent, ContentComponent],
})
export class PrivacyPolicyComponent {
  protected readonly CEO_CONFIG = CEO_CONFIG;

  public heroConfig = {
    slogan: "Privacy policy",
    isPrivacyPolicy: true,
    isHeroPrivacyPolicy: true,
    background: "privacy-policy-bg",
  };
}
